import React from 'react';

import './css/style-landing-page.css';

import { Outlet, useLocation } from 'react-router-dom';
import { Layout } from 'antd';

const { Content } = Layout;

const CommonPage = () => {
  const location = useLocation();
  const isLanding = location.pathname === '/';
  const surfaceClassName = isLanding ? 'page-surface landing-surface' : 'page-surface';
  const contentClassName = isLanding ? 'app-content app-content--landing' : 'app-content';

  return (
    <Layout className="app-layout">
        <Content className={contentClassName}>
            <div className={surfaceClassName}>
                <Outlet />
            </div>
        </Content>
    </Layout>
  );
}

export default CommonPage ;
